import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function MouseIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m2 2 7.07 16.97 2.51-7.39 7.39-2.51L2 2Zm10 10 6 6"
      />
    </Icon>
  );
}
